(() => {
  if (customElements.get('hexcaps-pairings')) return;
  class HexcapsPairings extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.refresh(false);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh(true));
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.unsubscribe?.();
      this.started = false;
    }
    async refresh(cartChanged) {
      this.controller?.abort();
      const controller = new AbortController();
      this.controller = controller;
      try {
        const response = await fetch(this.dataset.url, { signal: controller.signal });
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const replacement = doc.getElementById(this.id);
        if (!replacement || !this.isConnected || controller.signal.aborted) return;
        // Do not replace a button the shopper is interacting with during the initial load.
        if (!cartChanged && this.contains(document.activeElement)) return;
        const list = replacement.querySelector('.hx-pairs__list');
        if (!list) return;
        this.querySelector('.hx-pairs__list').replaceWith(list);
        this.hidden = !list.querySelector('.hx-pairs__row');
        this.dataset.source = replacement.dataset.source;
      } catch (error) {
        // Keep the server-rendered suggestions if recommendations are unavailable.
      }
    }
  }
  customElements.define('hexcaps-pairings', HexcapsPairings);
})();
